import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import { useParams } from "react-router";

import Select from "react-select";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { useForm, Controller } from "react-hook-form";

import config from "config.json";

import { createGame, getGameById, putGame } from "services/game_service";

function App() {
  const { register, handleSubmit, setValue, control } = useForm({});
  const navigate = useNavigate();

  const [gameTimestamp, setGameTimestamp] = useState(null);
  const [gameCallTimestamp, setGameCallTimestamp] = useState(null);
  const [gameLocation, setGameLocation] = useState(null);
  const { gameId } = useParams();

  useEffect(() => {
    async function fetchData() {
      if (!gameId) return;

      let game = await getGameById(gameId);

      setValue("team", game.attributes.team.data.id);
      setValue("opponent", game.attributes.opponent);
      setValue("competition", game.attributes.competition);
      setValue("game_call_location", game.attributes.game_call_location);
      setGameCallTimestamp(new Date(game.attributes.game_call_time));
      setGameTimestamp(new Date(game.attributes.date));
      setGameLocation(game.attributes.location);
    }
    fetchData();
  }, []);

  const submitForm = async (data) => {
    data = {
      ...data,
      location: gameLocation,
      date: gameTimestamp,
      game_call_time: gameTimestamp,
      season: config.CURRENT_SEASON,
    };
    if (!gameId) {
      await createGame(data);
      navigate("/jogos");
    } else {
      await putGame(gameId, data);
      navigate("/jogos");
    }

  };

  const canEditGame = () => {
    if (
      localStorage.getItem("role") === "Treinador" ||
      localStorage.getItem("role") === "Clube"
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/jogos"}>Jogos</Link> /{" "}
                {gameId ? "Editar Jogo" : "Novo Jogo"}
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Jogos</h1>
                  </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit((data) => submitForm(data))}>
              <div className="block">
                <div className="field">
                  <label className="label">Equipa</label>
                  <p className="control">
                    <Controller
                      name="team"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          isDisabled={!canEditGame()}
                          options={JSON.parse(
                            localStorage.getItem("teamIDs")
                          ).map((el) => ({ value: el.id, label: el.label }))}
                          value={JSON.parse(
                            localStorage.getItem("teamIDs")
                          ).find((c) => c.id === value)}
                          onChange={(val) => onChange(val.value)}
                        />
                      )}
                    />
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Adversário</label>
                  <p className="control">
                    <input
                      className="input"
                      type="text"
                      disabled={!canEditGame()}
                      {...register("opponent", {
                        required: true,
                        minLength: 5,
                      })}
                      placeholder={"Adversário"}
                    />
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Competição</label>
                  <p className="control">
                    <input
                      disabled={!canEditGame()}
                      className="input"
                      type="text"
                      {...register("competition", {
                        required: true,
                        minLength: 5,
                      })}
                      placeholder={"Taça de Portugal"}
                    />
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Localização do jogo</label>
                  <p className="control">
                    <div className="control">
                      <label className="radio">
                        <input
                          disabled={!canEditGame()}
                          type="radio"
                          checked={gameLocation === "home"}
                          onChange={(evt) => {
                            setGameLocation("home");
                          }}
                          name="answer"
                        />
                        Casa
                      </label>
                      <label className="radio">
                        <input
                          disabled={!canEditGame()}
                          onChange={(evt) => {
                            setGameLocation("away");
                          }}
                          checked={gameLocation === "away"}
                          type="radio"
                          name="answer"
                        />
                        Fora
                      </label>
                    </div>
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Data e hora do jogo</label>
                  <p className="control">
                    <DatePicker
                      scrollableYearDropdown
                      yearDropdownItemNumber={30}
                      disabled={!canEditGame()}
                      className="input"
                      selected={gameTimestamp}
                      value={gameTimestamp}
                      onChange={(value) => setGameTimestamp(value)}
                      timeIntervals={15}
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeFormat="HH:mm"
                      showTimeSelect
                    />
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Local da concentração</label>
                  <p className="control">
                    <input
                      disabled={!canEditGame()}
                      className="input"
                      type="text"
                      {...register("game_call_location", {
                        minLength: 3,
                      })}
                    />
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Data e hora da concentração</label>
                  <p className="control">
                    <DatePicker
                      scrollableYearDropdown
                      yearDropdownItemNumber={30}
                      disabled={!canEditGame()}
                      className="input"
                      selected={gameCallTimestamp}
                      value={gameCallTimestamp}
                      onChange={(value) => setGameCallTimestamp(value)}
                      timeIntervals={15}
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeFormat="HH:mm"
                      showTimeSelect
                    />
                  </p>
                </div>
              </div>
              {canEditGame() && <button className="button">Guardar</button>}
              &nbsp;&nbsp;&nbsp;&nbsp;
              {gameId && canEditGame() ? (
                <Link to={`/jogos/${gameId}/convocatoria`} className="button">
                  Convocatória
                </Link>
              ) : (
                ""
              )}
              &nbsp;&nbsp;&nbsp;&nbsp;
              {gameId && canEditGame() ? (
                <Link to={`/jogos/${gameId}/resultados`} className="button">
                  Adicionar Resultados
                </Link>
              ) : (
                ""
              )}
              &nbsp;&nbsp;&nbsp;&nbsp;
            </form>
          </section>
          <RightAdd></RightAdd>
         </div>

        </div>

      </div>
    </div>
  );
}

export default App;
